import useMutationCall from "../../../hooks/useMutationCall";
import { useAcceptOfferMutation } from "../offersSlice";

const useOfferAccept = () => {
  return useMutationCall(useAcceptOfferMutation);
};

export default useOfferAccept;
